import type { AudioObject } from '@powerplay/core-minigames'
import {
  AudioCategories,
  AudioGroups,
  AudioNames
} from '../types'
import { audioSprites } from './spriteAudioConfig'
/**
 * Trieda konfigu pre zvuky
 */
export const audioConfig: AudioObject[] = [

  ...audioSprites,

  {
    files: [
      AudioNames.yellMan
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    enabled: true,
    volume: 0.3,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    loop: false,
    sex: 'male',
    category: AudioCategories.character,
    group: AudioGroups.character,
  },
  {
    files: [
      AudioNames.yellWoman
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    enabled: true,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    loop: false,
    sex: 'female',
    category: AudioCategories.character,
    group: AudioGroups.character,
  },
  {
    files: [
      AudioNames.audienceIntroNoise
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    enabled: true,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    loop: true,
    category: AudioCategories.audience,
    group: AudioGroups.audience,
    version: 2
  },
  {
    files: [
      AudioNames.audienceCheering
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: true,
    category: AudioCategories.audience,
    group: AudioGroups.audience,
    version: 2
  },
  {
    files: [
      AudioNames.audienceIntroduction
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: true,
    category: AudioCategories.audience,
    group: AudioGroups.audience
  },
  {
    files: [
      AudioNames.audienceClapping
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 0.5,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: true,
    category: AudioCategories.audience,
    group: AudioGroups.audience
  },
  {
    files: [
      AudioNames.audienceFoul
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    category: AudioCategories.audience,
    group: AudioGroups.audience
  },
  {
    files: [
      AudioNames.audienceJavelinOnGround
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    category: AudioCategories.audience,
    group: AudioGroups.audience
  },
  {
    files: [
      AudioNames.audienceJavelinOnGroundBest
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    category: AudioCategories.audience,
    group: AudioGroups.audience
  },
  {
    files: [
      AudioNames.audienceOutro
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: true,
    category: AudioCategories.audience,
    group: AudioGroups.audience
  },
  {
    files: [
      AudioNames.commentatorIntro,
      AudioNames.commentatorIntro2
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    loadRandomCount: 1,
    category: AudioCategories.commentators,
    group: AudioGroups.commentators
  },
  {
    files: [
      AudioNames.commentatorBeforeFirstAttempt,
      AudioNames.commentatorBeforeFirstAttempt2
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    loadRandomCount: 1,
    category: AudioCategories.commentators,
    group: AudioGroups.commentators
  },
  {
    files: [
      AudioNames.commentatorProvisionalStandings,
      AudioNames.commentatorProvisionalStandings2
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    loadRandomCount: 1,
    category: AudioCategories.commentators,
    group: AudioGroups.commentators
  },
  {
    files: [
      AudioNames.commentatorFinalResults,
      AudioNames.commentatorFinalResults2
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    loadRandomCount: 1,
    category: AudioCategories.commentators,
    group: AudioGroups.commentators
  },

]
